//
//
//
//
//
//
//
//
//
//

/**
 * @figma https://www.figma.com/file/cBHD57QcCt9WDT4e7e2B3w/hse_general_library?node-id=413%3A1169
 * @storybook /?path=/story/layout-divider--playground
 * @react /src-components-divider
 * @reactStorybook /?path=/story/layout-divider--playground
 */
var script = {
  name: 'HseDivider',
  props: {
    /**
     * Вариант расположения
     * @values vertical, horizontal
     */
    variant: {
      type: String,
      default: 'horizontal'
    },
    /**
     * Цвет
     * @values light, dark
     */
    color: {
      type: String,
      validator: v => ['light', 'dark'].includes(v),
      default: 'light'
    }
  }
};

export default script;
